<template>
  <v-bottom-sheet v-model="isActive" persistent>
    <v-card>
      <div class="modal-header mb-4">
        <p class="title">Excluir tarefa</p>
      </div>

      <p class="confirm-text mb-2">Você tem certeza que deseja excluir esta tarefa?</p>

      <div class="modal-footer">
        <v-btn class="custom-btn cancel" elevation="0" @click="close">Cancelar</v-btn>
        <v-btn class="custom-btn delete" elevation="0" @click="confirmDelete">Excluir</v-btn>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'ModalConfirmDeleteInterval',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirmDelete() {
      this.$emit('confirm-delete');
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  padding: 16px 16px 24px 16px;
}

.modal-header {
  .title {
    color: #2d3748;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
    text-align: center !important;
    width: 100%;
  }
}

.confirm-text {
  color: #4a5568;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;

  .custom-btn {
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    height: 40px;
    letter-spacing: 0.3px;
    text-transform: none;
    width: 48%;

    &.delete {
      color: #fff;
      background-color: #f56565;
    }

    &.cancel {
      border: 1px solid #e2e8f0;
      background-color: #fff;
      color: #4a5568;
    }
  }
}
</style>
